export default __webpack_public_path__ + "static/media/main_section19.dc5e1058.jpg";